const ITEMS = [
  "Stavitelství jako umění",
  "Nejsme firma — aliance řemeslníků",
  "Dům na klíč za 90 dnů",
  "Bytová jádra za 7 dnů",
  "Záruka 60 měsíců",
  "Přes 20 let praxe",
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((t, i) => (
        <span key={i} className="flex items-center">
          <span className="font-sans font-medium text-base sm:text-lg uppercase tracking-[0.18em] text-zinc-500 whitespace-nowrap px-8">
            {t}
          </span>
          <span className="w-1.5 h-1.5 rotate-45 bg-gold/70 shrink-0" />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="editorial-marquee"
      className="py-7 border-y border-gold/10 bg-coal/60 overflow-hidden select-none"
    >
      <div className="marquee-track flex w-max">{[row("a"), row("b")]}</div>
    </div>
  );
}
